import * as types from './types';

const initialState = {};

function setAllPolicies(state, action) {
    return {
        ...state,
        ...action.payload,
    };
}

function setPolicy(state, action) {
    const {
        meta: carrierCode,
        payload: policy,
    } = action;

    return {
        ...state,
        [carrierCode]: policy,
    };
}

const reducerFunctions = {
    [types.SET_ALL_POLICIES]: setAllPolicies,
    [types.SET_POLICY]: setPolicy,
};

function reducer(state = initialState, action = {}) {
    if (!Object.prototype.hasOwnProperty.call(reducerFunctions, action.type)) {
        return state;
    }

    return reducerFunctions[action.type](state, action);
}

export default reducer;
